import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { VietMeetTrackEvents } from '../vietmeet-lib';
import { trackStreamingStatusChanged } from './actions.any';
/**
 * Syncs the initial track streaming status into redux and keeps it in sync via events.
 *
 * @param {ITrack | undefined} track - The track to sync.
 * @returns {void}
 */
export function useTrackStreamingStatus(track) {
    const dispatch = useDispatch();
    const vietmeetTrack = track?.vietmeetTrack;
    const sourceName = vietmeetTrack?.getSourceName();
    const handleStreamingStatusChanged = (changedTrack, streamingStatus) => {
        dispatch(trackStreamingStatusChanged(changedTrack, streamingStatus));
    };
    useEffect(() => {
        if (!track || track.local) {
            return;
        }
        track.vietmeetTrack.on(VietMeetTrackEvents.TRACK_STREAMING_STATUS_CHANGED, handleStreamingStatusChanged);
        dispatch(trackStreamingStatusChanged(track.vietmeetTrack, track.vietmeetTrack.getTrackStreamingStatus?.()));
        return () => {
            track.vietmeetTrack.off(VietMeetTrackEvents.TRACK_STREAMING_STATUS_CHANGED, handleStreamingStatusChanged);
            dispatch(trackStreamingStatusChanged(track.vietmeetTrack, track.vietmeetTrack.getTrackStreamingStatus?.()));
        };
        // The dependency must be the track OBJECT, not its source name: on a P2P<->JVB switch the remote track is
        // replaced by a new VietMeetRemoteTrack with the SAME source name. Keying on the source name leaves the
        // listener on the old (removed) track and nobody subscribed to the new one, so once its streaming status
        // tracker is disposed the status is stuck as null in redux and the tile falls back to the avatar while
        // video is in fact flowing.
    }, [vietmeetTrack, sourceName]);
}
